export const formatNumber = (num) => {
    if (num >= 1000000) {
        const formatted = Math.round(num / 100000) / 10;
        return (formatted % 1 === 0 ? Math.floor(formatted) : formatted.toFixed(1)) + 'M';
    }
    if (num >= 1000) {
        const formatted = Math.round(num / 100) / 10;
        // If rounding pushes us to 1000k or higher, convert to millions
        if (formatted >= 1000) {
            const millionsFormatted = Math.round(num / 100000) / 10;
            return (millionsFormatted % 1 === 0 ? Math.floor(millionsFormatted) : millionsFormatted.toFixed(1)) + 'M';
        }
        return (formatted % 1 === 0 ? Math.floor(formatted) : formatted.toFixed(1)) + 'k';
    }
    return num.toString();
};
